/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import { InputText } from "primereact/inputtext";
import React from "react";

export default function InputTextPR({ field, handleBlur, ...props }) {
  return (
    <InputText
      {...field}
      {...props}
      onBlur={(e) => {
        e.target.name = props.name;
        handleBlur(e);
      }}
    />
  );
}
